import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  positionElement as positionLayoutGroupElement
} from '../redux/layoutGroups'

export default function * requestPositionLayoutGroupElement (action) {
  const { layoutId, id, layoutGroupId, position } = action.payload

  const state = yield select()

  const layout = state['view-home'].layouts.byId[layoutId]

  if (!layout) throw new Error(`Layout ${layoutId} not found`)

  const layoutGroups = layout.layoutGroups
  const layoutGroupsByKey = state['view-home'].layoutGroupsByKey

  let element

  for (let i = 0, length = layoutGroups.length; i < length; i++) {
    const layoutGroup = layoutGroupsByKey[`${layoutId}-${layoutGroups[i]}`]
    element = layoutGroup.elements.find(element => element.id === id)

    if (element) {
      break
    }
  }

  if (!element) throw new Error(`Element ${id} not found`)

  const optimisticAction = yield optimisticPut(positionLayoutGroupElement({
    layoutId,
    groupId: layoutGroupId,
    elementId: id,
    position
  }))

  try {
    yield call(apiAction, 'PositionElementInLayoutGroup', {
      layoutId,
      id,
      groupId: layoutGroupId,
      position
    })
  } finally {
    yield optimisticAction.revert()
  }
}
